export const STANDARD = {
	value: "STANDARD",
};

export const TERMINATION = {
	value: "TERMINATION",
};

export const TEMPLATE = {
	value: "TEMPLATE",
};

export const CREDITS = {
	value: "CREDITS",
};

export const STANDARD_CREDITLESS = {
	value: "STANDARD_CREDITLESS"
};

export default [STANDARD, TERMINATION, TEMPLATE, CREDITS,STANDARD_CREDITLESS];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/enums/invoiceTypes.js